<template>

  <h5>Person Document Table Component Placeholder</h5>

</template> 
  
<script> 
  
  export default {
    name: "PersonDocumentTable",
    components: {
    }, 
    data(){
      return{
        isMounted : false,
      }
    },
    created(){ // called BEFORE rendering (load data here)

    },
    mounted() { // called afer rendering
      this.isMounted = true; 
    },

    methods:{
      ExampleMethod(){

      }
    },
    unmounted(){ //called when the page is left or the component is destroyed

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    }
  }
</script>
  
<style scoped>
</style>
